import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

//import { registerLocaleData } from '@angular/common';
//import localeEn from '@angular/common/locales/en';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';

import { AlertController } from '@ionic/angular';
import { Camera } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { DateService } from '../services/date';
import { GeocoderService } from '../services/geocoder';
import { RequestService } from '../services/request';
import { StorageService } from '../services/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { Events } from 'src/utilities/Events';

//registerLocaleData(localeEn, 'en-US');

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule, 
    IonicStorageModule.forRoot()
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Geolocation, 
    NativeGeocoder,
    AlertController, 
    DateService, 
    GeocoderService, 
    RequestService, 
    StorageService,
    Camera, 
    File, 
    FilePath,
    FileTransfer, 
    WebView,
    InAppBrowser,
    Events,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    //{provide: LOCALE_ID, useValue: 'en-US' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
